var map = {
	"./de-haagse-zorg-tech-basisinfrastructuur.md": [
		51,
		3
	],
	"./doelen-opgave-zorg-innovatie.md": [
		52,
		4
	],
	"./innovatie-en-adoptie-van-technologie.md": [
		53,
		5
	],
	"./innovatie-in-de-zorgketen.md": [
		54,
		6
	],
	"./innovatiekracht-tech-ondernemers-benutten.md": [
		55,
		7
	],
	"./jmo-slimmer-en-betaalbaar.md": [
		56,
		8
	],
	"./kenmerken-sociaal-domein.md": [
		57,
		9
	],
	"./kenmerken-tech-wereld.md": [
		58,
		10
	],
	"./onafhankelijke-informatie-en-advies.md": [
		59,
		11
	],
	"./opbrengst-voor-sociaal-domein-bedrijvigheid-en-Werkgelegenheid.md": [
		60,
		12
	],
	"./pijlers-opgave-zorg-innovatie.md": [
		61,
		13
	],
	"./samen-met-inwoners.md": [
		62,
		14
	],
	"./samen-onderzoeken-leren.md": [
		63,
		15
	],
	"./technology-and-innovation.md": [
		64,
		16
	],
	"./zorg-en-ondersteuning.md": [
		65,
		17
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 47;
module.exports = webpackAsyncContext;